import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_VALORACION } from "@/lib/site";

const WhatsAppFloat = () => (
  <motion.a
    href={WA_VALORACION}
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp directo"
    data-testid="whatsapp-float-button"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-gold text-ink flex items-center justify-center shadow-[0_8px_30px_rgba(197,160,89,0.45)]"
  >
    <MessageCircle size={24} strokeWidth={1.8} />
  </motion.a>
);

export default WhatsAppFloat;
